import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LogoutButton = () => {
  const { signOut } = useAuth();

  return (
    <button
      onClick={signOut}
      className="flex items-center gap-2 text-xs text-red-500 hover:text-red-700 transition-colors p-2"
    >
      <LogOut size={14} /> Esci
    </button>
  );
};

export default LogoutButton;
